import * as styles from "./ApplicationInfo.module.css";

import { ButtonLink } from "@components/ui";
import { ButtonStyle } from "@models/component-props";
import { HtmlOutput } from "@components/html";
import React from "react";

/**
 * Renders a section with information about the application process on the careers
 * opportunities page.
 *
 * @param {{ title: string, content: string, buttonText: string, completeTitle: string, completeContent: string, tagline: string }} props
 * The props object containing the title, content, button text, complete title,
 * complete content and tagline to be used in the component.
 * @returns {JSX.Element} The rendered component.
 */
const ApplicationInfo = ({
  title,
  content,
  buttonText,
  completeTitle,
  completeContent,
  tagline,
}: {
  title: string;
  content: string;
  buttonText: string;
  completeTitle: string;
  completeContent: string;
  tagline: string;
}) => {
  return (
    <section className={`inner ${styles.applicationInfoContainer}`}>
      {/* Section with title, details and link to scroll to the application form */}
      <div className={styles.applicationInfoSection1}>
        <h2>{title}</h2>
        <HtmlOutput html={content} />
        <ButtonLink
          link="#opportunitiesApplication"
          title={buttonText}
          buttonStyle={ButtonStyle.Tertiary}
        />
      </div>

      {/* Section with title and more details */}
      <div className={styles.applicationInfoSection2}>
        <h2>{completeTitle}</h2>
        <HtmlOutput html={completeContent} />
      </div>

      {/* Small tagline to appear underneat this section */}
      <div className={styles.applicationInfoTagline}>
        <strong>{tagline}</strong>
      </div>
    </section>
  );
};

export default ApplicationInfo;
